import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "dateview" }
const _hoisted_2 = { class: "leftcontent" }
const _hoisted_3 = { class: "activitybox flex column" }
const _hoisted_4 = { class: "flex column grow-1" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = {
  key: 0,
  class: "flex alert"
}
const _hoisted_8 = { class: "copy" }
const _hoisted_9 = { class: "flex column grow-1" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "description" }
const _hoisted_12 = {
  key: 0,
  class: "flex alert"
}
const _hoisted_13 = { class: "copy" }
const _hoisted_14 = { class: "flex v-center" }
const _hoisted_15 = { class: "flex gap grow-1" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "datepicker"
}
const _hoisted_19 = { class: "rightcontent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_selector = _resolveComponent("activity-selector")!
  const _component_month_availability = _resolveComponent("month-availability")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_activity_selector, { validate: "date" }),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { package: _ctx.isPackage }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["ratebox flex v-center", { selected: _ctx.isTodaySelected }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setDate(_ctx.today)))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex gap" }, [
                _createElementVNode("div", { class: "title" }, "Today")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.todayString), 1)
              ])
            ]),
            (_ctx.warningFor(_ctx.today))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "gg-danger" }, null, -1)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.warningFor(_ctx.today)), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex" }, [
              _createElementVNode("div", { class: "gg-check big check" })
            ], -1))
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["ratebox flex v-center", { selected: _ctx.isTomorrowSelected }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setDate(_ctx.tomorrow)))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex gap" }, [
                _createElementVNode("div", { class: "title" }, "Tomorrow")
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.tomorrowString), 1)
              ])
            ]),
            (_ctx.warningFor(_ctx.tomorrow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "gg-danger" }, null, -1)),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.warningFor(_ctx.tomorrow)), 1)
                ]))
              : _createCommentVNode("", true),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex" }, [
              _createElementVNode("div", { class: "gg-check big check" })
            ], -1))
          ], 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["ratebox flex column", { selected: _ctx.isOtherSelected }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDate(_ctx.thirdDay)))
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[11] || (_cache[11] = _createTextVNode(" Select different date ", -1)),
                (_ctx.isOtherSelected)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_ctx.otherString), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex" }, [
              _createElementVNode("div", { class: "gg-check big check" })
            ], -1))
          ]),
          (_ctx.isOtherSelected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_month_availability, {
                  selectedDate: _ctx.selectedDate,
                  onOnSelect: _ctx.setDate
                }, null, 8, ["selectedDate", "onOnSelect"])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", {
          class: _normalizeClass(["bookbutton", { broken: !_ctx.canProceed }]),
          onTouchstart: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"])),
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]))
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("div", { class: "gg-arrow-right-o" }, null, -1),
          _createElementVNode("div", null, "NEXT", -1)
        ]), 34)
      ])
    ], 2)
  ]))
}